import { render, staticRenderFns } from "./addAdvertise.vue?vue&type=template&id=d8b496de&scoped=true&"
import script from "./addAdvertise.vue?vue&type=script&lang=js&"
export * from "./addAdvertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b496de",
  null
  
)

export default component.exports